function viewportQuarter(el) {
  const { left, right, top, bottom } = el.getBoundingClientRect();
  const { vpW, vpH } = { vpW: window.innerWidth, vpH: window.innerHeight };

  return { isLeftSide: left < vpW - right, isTopSide: top < vpH - bottom };
}

function placeDropdown(target, anchor, viewportMargin = 0) {
  const { isTopSide } = viewportQuarter(anchor);
  const anchorRect = anchor.getBoundingClientRect();
  const vpH = window.innerHeight;

  target.style.position = 'fixed';
  target.style.maxHeight = 'unset';
  target.style.top = 'unset';
  target.style.right = 'unset';
  target.style.bottom = 'unset';
  target.style.left = anchorRect.left + 'px';
  target.style.width = anchorRect.width + 'px';

  if (isTopSide) {
    target.style.top = anchorRect.bottom + 'px';
    const maxH = vpH - anchorRect.bottom;
    target.style.maxHeight = maxH - viewportMargin + 'px';

    target.classList.remove('dropdown-above');
    target.classList.add('dropdown-below');
  } else {
    target.style.bottom = vpH - anchorRect.top + 'px';
    const maxH = anchorRect.top;
    target.style.maxHeight = maxH - viewportMargin + 'px';

    target.classList.remove('dropdown-below');
    target.classList.add('dropdown-above');
  }
}

function createRecursiveIntersectionWatcher(
  target,
  { onEnter = () => {}, onLeave = () => {}, threshold = 0, axis = 'both' } = {},
) {
  let observers = [];
  let visibleMap = new Map();
  let wasFullyVisible = null;

  function isVisible(entry) {
    const { intersectionRect, boundingClientRect } = entry;

    if (axis === 'x') {
      return intersectionRect.width >= boundingClientRect.width * threshold;
    }
    if (axis === 'y') {
      return intersectionRect.height >= boundingClientRect.height * threshold;
    }
    return entry.isIntersecting;
  }

  function updateState() {
    const fullyVisible = [...visibleMap.values()].every((v) => v);

    if (fullyVisible && wasFullyVisible === false) {
      onEnter();
    } else if (!fullyVisible && wasFullyVisible === true) {
      onLeave();
    }

    wasFullyVisible = fullyVisible;
  }

  function start() {
    if (!target || observers.length) return;

    const parents = getScrollableParents(target);
    visibleMap = new Map(parents.map((p) => [p, true]));

    observers = parents.map((parent) => {
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            visibleMap.set(parent, isVisible(entry));
            updateState();
          });
        },
        { root: parent, threshold },
      );
      obs.observe(target);
      return obs;
    });
  }

  function stop() {
    observers.forEach((o) => o.disconnect());
    observers = [];
    visibleMap.clear();
    wasFullyVisible = null;
  }

  return { start, stop };
}

function getScrollableParents(el) {
  const parents = [];
  let parent = el.parentElement;

  while (parent) {
    const style = getComputedStyle(parent);
    const overflowX = style.overflowX;
    const overflowY = style.overflowY;

    if (
      overflowX === 'auto' ||
      overflowX === 'scroll' ||
      overflowY === 'auto' ||
      overflowY === 'scroll'
    ) {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}

export { viewportQuarter, placeDropdown, getScrollableParents, createRecursiveIntersectionWatcher };
